import LeftAslide from './index.vue'

LeftAslide.install = function (Vue) {
  Vue.component(LeftAslide.name, LeftAslide)
}

export default LeftAslide
